import Vue from 'vue'
import Vuex from 'vuex'
import paint from './modules/paint_canvas'
import simulator from './modules/simulator'
import item_data from './modules/item_data'
import Util from '../assets/js/util'
import CONST from '../assets/js/const'

Vue.use(Vuex);

let timer_id = 0;

export default new Vuex.Store({
  state: {
    konva_stage: null, //シミュレーターを描画しているkonvaのstage

    display_modal_name: '',

    current_image: '',
    user_upload_img: '',
    background_img: null, //背景画像 imgのDOMを想定
    clipping_img: null,
    is_loading: false, //ローディング中はtrueに設定 mutationとv-ifで勝手にローディングモーダルが開く
    rect_height: 3000,
    rect_width: 2500,

    menu_mode:CONST.MENU_MODE_DEFAULT,

    perspective: null,

    canvas_scale: 1, //キャンバスをtransform:scaleで縮小するのでその比率

    input_scale: 1, //図の拡大率※ユーザー操作部分
    scale_max: 3.0, //最大倍率
    scale_min: 0.5, //最小倍率

    is_check_pattern: false, //順貼り(false) or 市松貼り(true)
    is_curtain: false,

    edit_rect_is_visible: true,
    user_controlling: false,

    show_mom: false,
    mom_reply: [() => null, () => null],

    edit_mode: CONST.EDIT_MODE_DEFAULT,
    is_creating_image: false,
  },
  mutations: {
    setStage(state, stage) { state.konva_stage = stage },
    setModal(state, data) { state.display_modal_name = data; state.show_mom = false },
    scaleUp(state) {
      if (state.input_scale * 1.15 < state.scale_max) {
        const up_scale = Util.roundOffWithDecimalPlace(state.input_scale * 1.15, 12);
        state.input_scale = Math.abs(1 - up_scale) < 0.01 ? 1 : up_scale;
      }
    },
    scaleDown(state) {
      if (state.input_scale / 1.15 > state.scale_min) {
        const down_scale = Util.roundOffWithDecimalPlace(state.input_scale / 1.15, 12);
        state.input_scale = Math.abs(1 - down_scale) < 0.01 ? 1 : down_scale;
      }
    },
    resetScale(state) { state.input_scale = 1 },
    setCurrentImage(state, file_name){
      state.current_image = file_name;
    },
    setUserUploadImage(state, file_name){
      state.user_upload_img = file_name;
    },
    setBackgroundImage(state, img_el){
      state.background_img = img_el;
    },
    setClippingImage(state, image_el){
      state.clipping_img = image_el;
    },
    setIsLoading(state, bool){
      state.is_loading = bool;
      //document.body.style.overflow = bool ? 'hidden' : 'auto';
    },
    setRectHeight(state, size){
      state.rect_height = Number(size);
    },
    setRectWidth(state, size){
      state.rect_width = Number(size);
    },
    setMenuMode(state, mode){
      state.menu_mode = mode;
    },
    setCanvasScale(state, scale){
      state.canvas_scale = Number(scale);
    },
    setEditMode(state, mode){
      state.edit_mode = mode;
    },
    setCheckPattern(state, bool){
      state.is_check_pattern = bool;
    },
    setIsCurtain(state, bool){
      state.is_curtain = bool;
    },
    setEditRectIsVisible(state, bool){
      state.edit_rect_is_visible = bool;
    },
    setUserControlling(state, bool){
      state.user_controlling = bool;
    },
    setPerspective(state, perspective){
      state.perspective = perspective;
    },
    toggleMoM (state) {
      state.show_mom = !state.show_mom;
    },
    setMoMFunc (state, func) {
      state.mom_reply = func;
    },
    setIsCreatingImage(state, bool){
      state.is_creating_image = bool;
    },
  },
  actions: {
    resetTimer({ commit }) {
      // if(timer_id) { clearInterval(timer_id) }
      commit("setUserControlling", true);
      // timer_id = setTimeout(() => { commit("setUserControlling", false); }, 2500);
    }
  },
  getters: {
    modal_name (state) {
      return state.display_modal_name
    }
  },
  modules: { paint,  simulator, item_data }
})
